// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1400":"2c1d3142","1837":"4d09e8b7","2314":"475a977c","3323":"c7925742","3743":"22acbef5","6426":"bfc7cac7","9415":"bfc7cac7"}[chunkId] + ".chunk.css";
};